import { useEffect, useMemo } from "react"
import { makeAutoObservable } from "mobx"

class AgentLinkStore {
  isLinkCopied: boolean
  shareLink: string | null

  constructor() {
    this.isLinkCopied = false
    this.shareLink = null

    makeAutoObservable(this)
  }

  setIsLinkCopied(isLinkCopied: boolean) {
    this.isLinkCopied = isLinkCopied
  }

  setShareLink(shareLink: string | null) {
    this.shareLink = shareLink
  }
}

export const useAgentLink = (agentLink?: string) => {
  const store = useMemo(() => new AgentLinkStore(), [])

  const copyLinkToClipboard = (link: string) => {
    navigator.clipboard.writeText(link)
    store.setIsLinkCopied(true)
    console.log("Link is copied to clipboard", link)

    setTimeout(() => {
      store.setIsLinkCopied(false)
    }, 3000)
  }

  const copyLink = () => {
    if (!store.shareLink) {
      alert(
        "Link generation may not work properly if browser blockers are enabled; please disable them for the best experience.",
      )
      return
    }
    copyLinkToClipboard(store.shareLink)
  }

  useEffect(() => {
    if (agentLink) {
      store.setShareLink(agentLink)
    }
  }, [agentLink])

  return {
    copyLink,
    shareLink: store.shareLink,
    isLinkCopied: store.isLinkCopied,
  }
}
